// extracted by mini-css-extract-plugin
module.exports = {"card":"ApyStat_card__wMBhq","title":"ApyStat_title__eKHmI","apy":"ApyStat_apy__zWxFW"};